import { Fragment, ReactNode } from "react";
import { faAngleRight } from "@fortawesome/pro-regular-svg-icons";

import Icon from "common/components/Icon";

import styles from "../../styles/Breadcrumbs.module.less";

type BreadcrumbsProps = {
  items: ReactNode[];
  className?: string;
};

const Breadcrumbs = ({ items, className = "" }: BreadcrumbsProps) => {
  return (
    <div className={`${styles.container} ${className}`}>
      {items.map((item, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={idx}>
          <div className={styles.item}>{item}</div>
          {idx < items.length - 1 && <Icon icon={faAngleRight} className={styles.icon} />}
        </Fragment>
      ))}
    </div>
  );
};

export default Breadcrumbs;
